var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51343 0.000192909C2.67973 0.000192909 2.83015 0.0682468 2.93843 0.178057L4.8519 2.09395C5.08513 2.32747 5.08513 2.7061 4.8519 2.93963C4.61867 3.17316 4.24052 3.17316 4.00729 2.93963L3.11066 2.04186V11.4021C3.11066 11.7324 2.84327 12.0001 2.51343 12.0001C2.18359 12.0001 1.9162 11.7324 1.9162 11.4021V2.04183L1.01954 2.93963C0.786303 3.17316 0.408158 3.17316 0.174925 2.93963C-0.0583082 2.7061 -0.0583082 2.32747 0.174925 2.09395L2.09111 0.175339C2.10273 0.1637 2.11478 0.15259 2.12723 0.142025C2.23136 0.0535569 2.36617 0.000192909 2.51343 0.000192909Z",
    fill: "#676879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33731 11.9999C8.50361 11.9999 8.65403 11.9319 8.76232 11.8221L10.6758 9.90618C10.909 9.67265 10.909 9.29402 10.6758 9.0605C10.4426 8.82697 10.0644 8.82697 9.83117 9.0605L8.93454 9.95826V0.597998C8.93454 0.267739 8.66715 1.14441e-05 8.33731 1.14441e-05C8.00747 1.14441e-05 7.74008 0.267739 7.74008 0.597998V9.95829L6.84342 9.0605C6.61019 8.82697 6.23204 8.82697 5.99881 9.0605C5.76557 9.29402 5.76557 9.67265 5.99881 9.90618L7.91499 11.8248C7.92661 11.8364 7.93867 11.8475 7.95111 11.8581C8.05524 11.9466 8.19005 11.9999 8.33731 11.9999Z",
    fill: "#676879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDown);
export default __webpack_public_path__ + "static/media/UpDown.f3b704029dcc0bae971276e93d01a2e3.svg";
export { ForwardRef as ReactComponent };